import axios from "axios";

const IBModuleApi = axios.create();

IBModuleApi.interceptors.request.use((config) => {
  config.headers!.SESSIONID = sessionStorage.getItem("SESSIONID") || "";
  config.headers!.CORRELATION = sessionStorage.getItem("CORRELATION") || "";
  config.headers!.AUTHORIZATION = `Bearer ${sessionStorage.getItem('REDIRECT::INFO') || new URLSearchParams(window.location.search).get('token') || ''}`;
  config.headers!.ENV = sessionStorage.getItem("ENV") || "";
  config.headers!.LANG = localStorage.getItem("LANGUAGE") || "";
  return config;
});

export default IBModuleApi;
